import React from "react";
import "./Loading.scss"; // Import the CSS file

const Loading = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      <img
        className="fadeIn"
        src="../../../../images/ijcai_logo.png"
        width="350"
        height="132"
        alt="IJCAI "
        id="ijcailogo"
      />
     
    </div>
  );
};

export default Loading;
